import { SurveyFormatRef, PayloadActionCreator, SurveyFormatType } from './types';
import { SurveyAction } from './constants';

export const register: PayloadActionCreator<typeof SurveyAction.REGISTER, SurveyFormatRef> = ref => ({
  type: SurveyAction.REGISTER,
  payload: ref,
});

export const unregister: PayloadActionCreator<typeof SurveyAction.UNREGISTER, SurveyFormatRef['name']> = name => ({
  type: SurveyAction.UNREGISTER,
  payload: name,
});

export const setActive: PayloadActionCreator<typeof SurveyAction.SET_ACTIVE, SurveyFormatRef['name'] | null> =
  name => ({
    type: SurveyAction.SET_ACTIVE,
    payload: name,
  });

export const setFormat: PayloadActionCreator<typeof SurveyAction.SET_FORMAT, SurveyFormatType> = format => ({
  type: SurveyAction.SET_FORMAT,
  payload: format,
});
